import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Icons } from 'src/app/core/enums/icons.enum';
import { AuthService } from 'src/app/core/services/auth.service';
import { ClientLoginService } from 'src/app/core/services/client-login.service';
import { PortalStateService } from 'src/app/core/services/portal-state.service';
import { PortalApp } from 'src/app/core/shared/portal-app';
import { Application } from 'src/portaljs/constants/application';
import { MessageType } from 'src/portaljs/constants/message-type';
import { UserStateEvent } from 'src/portaljs/models/user-state-event';
import { Message } from 'src/portaljs/models/message';
import { UserEvent } from 'src/portaljs/constants/user-event';
import { LoginPrompt } from 'src/app/core/enums/login-prompt.enum';
import { AuthType } from 'src/app/core/enums/auth.type.enum';
import { AuthenticationEvent } from 'src/app/core/models/authentication-event.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'fss-portal-client-login-dialog',
    templateUrl: './client-login-dialog.component.html',
    styleUrls: ['./client-login-dialog.component.scss'],
    standalone: false
})
export class ClientLoginDialogComponent  implements OnInit, OnDestroy {
  public requestingApp: Application;
  public icons = Icons;
  private ngUnsubscribe = new Subject();

  constructor(private clientLoginService: ClientLoginService,
              private portalStateService: PortalStateService,
              private authSvc: AuthService,
              private dialogRef: MatDialogRef<ClientLoginDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.requestingApp = data.loginRequestedBy;
  }

  public ngOnInit() {
    this.dialogRef.backdropClick().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.cancel();
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  public login() {
    this.dialogRef.close();
    this.authSvc.initiateAuthentication(new AuthenticationEvent(LoginPrompt.LOGIN, AuthType.LOGIN, this.authSvc.getSiteGuid(), 'client-login-dialog'));
  }

  public cancel() {
    const portalApp: PortalApp = this.portalStateService.getActiveApp();
    if (portalApp.app !== Application.PORTAL) {
      const userState: UserStateEvent = {event: UserEvent.LOGIN_CANCELED};
      const msg = new Message(undefined, MessageType.userStateChange, Application.PORTAL, portalApp.app, userState );
      this.portalStateService.postMessage(msg);
    }
  }

}
